import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.629 4.5-6.44 6.439a1.5 1.5 0 0 0 0 2.121l6.44 6.44m8.742-15 6.44 6.439a1.5 1.5 0 0 1 0 2.121l-6.44 6.44"
    }, null, -1)
  ]));
}
const programmingScriptCode = { render };
export {
  programmingScriptCode as default,
  render
};
//# sourceMappingURL=programming-script-code.svg.js.map
